"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAll = getAll;
exports.getAllActif = getAllActif;
exports.getAllBySocieteId = getAllBySocieteId;
exports.getAllActifBySocieteId = getAllActifBySocieteId;
exports.getAllByIdClient = getAllByIdClient;
exports.getAllActifByIdClient = getAllActifByIdClient;
exports.getById = getById;
exports.update = update;
exports.insert = insert;
exports.deleteById = deleteById;
exports.bulkDelete = bulkDelete;

var _request = _interopRequireDefault(require("@/helpers/request"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getAll() {
  return (0, _request.default)({
    url: '/enseigne',
    method: 'get'
  });
}

function getAllActif() {
  return (0, _request.default)({
    url: '/enseigne/actif',
    method: 'get'
  });
}

function getAllBySocieteId(id) {
  return (0, _request.default)({
    url: '/enseigne/societe/' + id,
    method: 'get'
  });
}

function getAllActifBySocieteId(id) {
  return (0, _request.default)({
    url: '/enseigne/actif/societe/' + id,
    method: 'get'
  });
}

function getAllByIdClient(id) {
  return (0, _request.default)({
    url: '/enseigne/client/' + id,
    method: 'get'
  });
}

function getAllActifByIdClient(id) {
  return (0, _request.default)({
    url: '/enseigne/actif/client/' + id,
    method: 'get'
  });
}

function getById(id) {
  return (0, _request.default)({
    url: '/enseigne/' + id,
    method: 'get'
  });
}

function update(id, data) {
  return (0, _request.default)({
    url: '/enseigne/' + id,
    method: 'put',
    data: data
  });
}

function insert(data) {
  return (0, _request.default)({
    url: '/enseigne',
    method: 'post',
    data: data
  });
}

function deleteById(id) {
  return (0, _request.default)({
    url: '/enseigne/' + id,
    method: 'delete'
  });
}

function bulkDelete(ids) {
  return (0, _request.default)({
    url: '/enseigne/' + ids,
    method: 'delete'
  });
}